import moment from 'moment';
import Pikaday from 'pikaday';

import {
    debug as logDebug,
    error as logError
} from '../utils/logger';

function getDateTimeOptions(state) {
    return _.get(state, 'core.featureConfigs.datetimeOptions');
}

let datePickerRegistry = {};

function addToRegistry(component, picker) {
    if (picker) {
        const key = component.templateLocation;
        datePickerRegistry[key] = picker;
    }
}

function removeFromRegistry(component) {
    const key = component.templateLocation;

    if (key) {
        if (datePickerRegistry[key]) {
            const existingPicker = datePickerRegistry[key];

            existingPicker.destroy();
            delete datePickerRegistry[key];
        }
    }
}

export function removeDatePickers(component) {
    logDebug(`removing date pickers at ${component.templateLocation}`);
    removeFromRegistry(component);
}

export function weekdayOrchestration(weekdaysObj) {
    // datetimeOptions start with Monday but Pikaday assumes 0 = Sunday
    // so we need to shift the days by one
    let weekdays = weekdaysObj.weekdays;
    let weekdaysShort = weekdaysObj.weekdaysShort;

    weekdays.unshift(weekdays.pop());
    weekdaysShort.unshift(weekdaysShort.pop());

    return {
        weekdays: weekdays,
        weekdaysShort: weekdaysShort
    };
}

export function getPicker(templateLocation) {
    const key = templateLocation;

    if (key) {
        return datePickerRegistry[key];
    }

    return undefined;
}

export function addDatePickers(component, getState, pikadayConfigOverrides) {
    const datePickerSelector = component.scopedSelector('.js-date-picker');
    const state = getState();

    if (!datePickerSelector) {
        logError('Date picker selector is undefined!! Not adding date pickers to prevent further things from breaking.');
        return;
    }

    $(document).off('touchend click', datePickerSelector);
    removeDatePickers(component);

    logDebug(`creating date pickers at ${component.templateLocation}`);
    const dateTimeOptions = getDateTimeOptions(state);
    const dateFormat = (dateTimeOptions) ? dateTimeOptions.dateFormatString : 'MM-DD-YYYY';

    $(datePickerSelector).each((index, elem) => {
        let pickerConfig = {
            field: elem,
            bound: true,
            defaultDate: new Date(),
            setDefaultDate: true,
            onOpen: function() {
                $('.js-calendar-icon').addClass('c-date-picker__calendar--active');
            },
            onClose: function() {
                $('.js-calendar-icon').removeClass('c-date-picker__calendar--active');
            }
        };

        $(datePickerSelector).attr('data-date-format', dateFormat);

        if (dateTimeOptions) {
            const weekdaysObj = weekdayOrchestration({
                weekdays: _.clone(dateTimeOptions.weekdays),
                weekdaysShort: _.clone(dateTimeOptions.weekdaysShort)
            });

            pickerConfig.format = dateFormat;
            pickerConfig.firstDay = 0;
            pickerConfig.i18n = {
                months: dateTimeOptions.months,
                previousMonth: dateTimeOptions.prevMonthLabel,
                nextMonth: dateTimeOptions.nextMonthLabel,
                weekdays: weekdaysObj.weekdays,
                weekdaysShort: weekdaysObj.weekdaysShort
            };
        }

        if (pikadayConfigOverrides) {
            pickerConfig = Object.assign({}, pickerConfig, pikadayConfigOverrides);
        }

        logDebug('creating a picker');
        const picker = new Pikaday(pickerConfig);

        addToRegistry(component, picker);
    });

    // Disable calendar icon default click functionality
    $(component.scopedSelector('.js-calendar-icon')).on('click', (event) => {
        event.preventDefault();
    });

    $(document).on('click', datePickerSelector, (event) => {
        logDebug('showing pikaday picker');
        const picker = getPicker(component.templateLocation);

        if (picker) {
            picker.show();
        }
    });
}

// parsley validation support

if (window && window.Parsley) {
    if (!window.Parsley._validatorRegistry.dateHasFormat) {
        window.Parsley.addValidator('dateHasFormat', {
            requirementType: 'string',
            validateString: (value, dateFormat) => {
                function isBlank(val) {
                    return (!val || String(val).trim() === '');
                }

                if (!isBlank(value)) {
                    const momentInstance = moment(value, dateFormat, true);

                    if (!momentInstance.isValid()) {
                        return false;
                    }
                }

                return true;
            }
        });
    }
}
